import React, { Component } from 'react'
import classNames from 'classnames'
import * as dataService from '../../service/data-info-chart/requestsUtil'
import { AGENT_PERFORMANCE, OPERATION_LABEL, WHITOUT_INFORMATION } from '../../utils/constants'
import * as cbu from '../../utils/checkBusinessUnit'

import 'react-table/react-table.css'
import Loader from 'react-loader'

import * as Formatter from '../../utils/formatters'
import * as Parse from '../../utils/parsers'

class ManagerLawyerPerformance extends Component {

  constructor (props) {
    super(props)

    var moment = require('moment')
    require('moment/min/locales.min')
    //var today = Parse.toCustomDate(moment().locale("es-MX").toDate());
    var today = Parse.toCustomDateLastDay(this.props.date)

    this.state = {
      datas: [],
      buId: cbu.checkBusinessUnit(this.props.bu),
      totalAccounts: 0,
      totalAmounts: 0,
      date: today,
      currentPage: 0,
      totalPages: 0,
      loaded: false
    }
    this.fetchMore = this.fetchMore.bind(this)
  }

  componentDidMount () {
    dataService.getFetch(OPERATION_LABEL + cbu.checkBusinessUnit(this.props.bu) + AGENT_PERFORMANCE + this.state.date + '?page=0&size=20')
      .then((json) => {
        this.setState({
          datas: json.data.incomeLGS,
          totalAmounts: json.data.totalAmmounts,
          totalAccounts: json.data.totalAccounts,
          currentPage: json.pageNumber,
          totalPages: json.totalPages,
          loaded: true
        })
      })
  }

  fetchMore = (more) => {
    console.log(this.state)
    //this.setState({loaded: false});

    dataService.getFetch(OPERATION_LABEL + this.state.buId + AGENT_PERFORMANCE + this.state.date + '?page=' + (more ? (this.state.currentPage + 1) : (this.state.currentPage - 1)) + '&size=20')
      .then((json) => {
        this.setState({
          datas: json.data.incomeLGS,
          totalAmounts: json.data.totalAmmounts,
          totalAccounts: json.data.totalAccounts,
          currentPage: json.pageNumber,
          totalPages: json.totalPages,
          loaded: true
        })
      })
  }

  render () {

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': true,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    })

    let rows = this.state.datas.map((person) => {
      return <tr>
        <td>{person.name}</td>
        <td>{person.position}</td>
        <td>{Formatter.formatNumber(person.accounts)}</td>
        <td>{Formatter.formatNumberMoney(person.amount)}</td>
      </tr>
    })

    if (this.state.loaded) {

      var buttons

      if (this.state.totalPages === 0 || ((this.state.currentPage + 1 === this.state.totalPages) && this.state.totalPages === 1)) {
        buttons = <div className={'container-flex p-1'}>
          <div class="d-flex justify-content-between">
            <button className={'btn btn-secondary'} disabled={'disabled'}> Anterior</button>
            <h5>Página 1 de 1</h5>
            <button className={'btn btn-secondary'} disabled={'disabled'}> Siguiente</button>
          </div>
        </div>
      } else {
        if (this.state.currentPage === 0) {
          buttons = <div className={'container-flex p-1'}>
            <div class="d-flex justify-content-between">
              <button className={'btn btn-secondary'} disabled={'disabled'}> Anterior</button>
              <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
              <button className={'btn btn-secondary'} onClick={() => this.fetchMore(true)}> Siguiente</button>
            </div>
          </div>
        } else {
          if (this.state.currentPage + 1 === this.state.totalPages) {
            buttons = <div className={'container-flex p-1'}>
              <div class="d-flex justify-content-between">
                <button className={'btn btn-secondary'} onClick={() => this.fetchMore(false)}> Anterior</button>
                <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
                <button className={'btn btn-secondary'} disabled={'disabled'}> Siguiente</button>
              </div>
            </div>
          } else {
            buttons = <div className={'container-flex p-1'}>
              <div className="d-flex justify-content-between">
                <button className={'btn btn-secondary'} onClick={() => this.fetchMore(false)}> Anterior</button>
                <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
                <button className={'btn btn-secondary'} onClick={() => this.fetchMore(true)}> Siguiente</button>
              </div>
            </div>
          }
        }
      }
      return (
        <Loader top={'90%'} loaded={this.state.loaded}>
          <div className='scrollx'>
            <table className={tableClass}>
              <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
              <tr style={{height: '30px'}}>
                <th className={'align-middle'}>Nombre</th>
                <th className={'align-middle'}>Puesto</th>
                <th className={'align-middle'}>Cuentas</th>
                <th className={'align-middle'}>Ingreso recaudado</th>
              </tr>
              </thead>
              <tbody style={{color: '#000'}}>
              {rows}
              <tr>
                <th colSpan={2}>Total</th>
                <th>{Formatter.formatNumber(this.state.totalAccounts)}</th>
                <th>{Formatter.formatNumberMoney(this.state.totalAmounts)}</th>
              </tr>
              </tbody>
            </table>
            <div>
              {buttons}
            </div>
          </div>
        </Loader>
      )
    } else {
      return (
        <Loader loaded={this.state.loaded} top="50%"><h2
          className="without-avilable-information">{WHITOUT_INFORMATION}</h2>
        </Loader>)
    }
  }
}

export default ManagerLawyerPerformance



// WEBPACK FOOTER //
// ./src/components/tables/managerLawyerPerformance.js